// extracted by mini-css-extract-plugin
export default {"basic-popup":"BasicPopup_basic-popup__wwfjj","popup":"BasicPopup_popup__gIfpY"};